/** Material categories that use pipe traceability (NRI, pipe no., heat, etc.) on the server. */
export const PIPE_LIKE_MATERIAL_CATEGORIES = [
  'Pipe',
  'Bends',
  'Flanges',
  'Hydro',
  'Torquing',
  'Gauging',
  'Flushing',
] as const;

export type PipeLikeMaterialCategory = (typeof PIPE_LIKE_MATERIAL_CATEGORIES)[number];

export const isPipeLikeMaterialCategory = (
  category: string | undefined | null
): category is PipeLikeMaterialCategory =>
  category != null && (PIPE_LIKE_MATERIAL_CATEGORIES as readonly string[]).includes(category);

/** Fabrication sub-types that show Base Pipes, Bends, Flanges, Hydro, Torquing, Gauging, Flushing, etc. */
export const isBendsFlangesLayoutFabricSubType = (subType: string | undefined): boolean => {
  if (subType == null || subType === '') return false;
  const s = subType.toLowerCase();
  return s === 'bulkhead' || s === 'spools' || s === 'spool';
};

/** Tabs shown for spools / bulkhead fabrication material traceability. */
export const FABRIC_BENDS_FLANGES_MATERIAL_TAB_KEYS = [
  'pipe',
  'Bends',
  'Flanges',
  'hydro',
  'torquing',
  'gauging',
  'flushing',
  'gas',
  'wire',
  'coating',
  'misc',
] as const;

export type FabricBendsFlangesMaterialTabKey = (typeof FABRIC_BENDS_FLANGES_MATERIAL_TAB_KEYS)[number];

/** API grouped response key for each pipe-like category. */
export const PIPE_LIKE_CATEGORY_SETUP_DATA_KEY: Record<PipeLikeMaterialCategory, string> = {
  Pipe: 'pipes',
  Bends: 'bends',
  Flanges: 'flanges',
  Hydro: 'hydro',
  Torquing: 'torquing',
  Gauging: 'gauging',
  Flushing: 'flushing',
};
